import React from 'react';
import Typography from '../../../components/atoms/typography';
import CustomDataGrid from '../../../components/atoms/dataGrid';
import { Box } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';

const columns = [
  {
    field: 'corporateName',
    flex: 1,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        PDV
      </Typography>
    ),
  },
  {
    field: 'address',
    flex: 2,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        Endereço
      </Typography>
    ),
  },
  {
    field: 'totalWeight',
    flex: 1,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        Peso Total (Kg)
      </Typography>
    ),
  },
];

const PublishedFreightTable: React.FC = () => {
  const { getValues } = useFormContext();
  const freightDetails = getValues();

  const aggregatedRows = (freightDetails.deliveryRequests || []).reduce(
    (acc: any, item: any) => {
      const existing = acc.find(
        (row: any) => row.corporateName === item.corporateName,
      );
      if (existing) {
        existing.totalWeight += item.totalWeight;
      } else {
        acc.push({ ...item });
      }
      return acc;
    },
    [],
  );

  return (
    <Box component="div">
      <CustomDataGrid
        columns={columns}
        rows={aggregatedRows}
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        getRowId={row => row.corporateName}
        pageSize={20}
      />
    </Box>
  );
};

export default PublishedFreightTable;
